<template>
  <div class="m-l-50 m-t-30 w-800">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <!-- <el-form-item label="排序" prop="sort">
        <el-input v-model.trim="form.sort" class="h-40 w-200"></el-input>
      </el-form-item> -->
      <el-form-item label="标题" prop="title">
        <el-input v-model.trim="form.title" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="跳转地址" prop="url">
        <el-input v-model.trim="form.url" placeholder="请输入跳转地址"  class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <div v-if="form.img">
          <el-popover
            placement="right-end"
            width="600"
            trigger="click">
            <img :src="form.img" width="100%">
            <img :src="form.img" width="150" slot="reference">
          </el-popover>
        </div>
        <el-upload
        :action="uploadUrl"
        type="drag"
        :show-file-list="true"
        :on-preview="viewPic"
        :on-remove="handleRemove"
        :on-success="uploadSuccess"
        :on-error="uploadFail"
        :default-file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-dragger__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
        </el-upload>
      </el-form-item>
      <!-- <el-form-item label="商家点击累计">
        <el-select v-model="form.bid" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">提 交</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
    </el-form>
    <preview ref="preview" :url="propsImg"></preview>
  </div>
</template>
<style>
  .form-checkbox:first-child{
    margin-left: 15px;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  import preview from '../../../Common/preview.vue'

  export default {
    data() {
      return {
        isLoading: false,
        fileList: [],
        options: [],
        value: '',
        propsImg: '',
        form: {
          title: '',
          url: '',
          img: ''
        },
        rules: {
          title: [
            { required: true, message: '请填写标题' }
          ],
          url: [
            { required: true, message: '请输入地址' }
          ]
        }
      }
    },
    methods: {
      add(form) {
        console.log('res = ', _g.j2s(this.form))
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/lunbo', this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '添加成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      uploadSuccess(res, file, fileList) {
        this.form.img = res.data
        let data = {
          name: '图片',
          url: window.HOST + res.data
        }
        this.fileList.push(data)
      },
      uploadFail(err, res, file) {
        console.log('err = ', _g.j2s(err))
        console.log('res = ', _g.j2s(res))
      },
      handleRemove(file, fileList) {
        console.log('file = ', file)
        console.log('fileList = ', fileList)
      },
      viewPic() {
        this.propsImg = this.fileList[0].url
        this.$refs.preview.open()
      }
    },
    created() {
      this.uploadUrl = window.HOST + 'qiniu'
      _g.closeGlobalLoading()
      // this.getAllGroups()
    },
    components: {
      preview
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// add.vue?51ae0d42